import React from 'react'

const VideoWithTextIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    {...props}
    viewBox='7 7 45 45'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <path
        d='M20.943 7h22.36A1.69 1.69 0 0 1 45 8.682v22.433a1.69 1.69 0 0 1-1.698 1.681h-22.36a1.69 1.69 0 0 1-1.697-1.681V8.682c0-.93.76-1.682 1.698-1.682zm0 1.682v22.433h22.36V8.682h-22.36zm7.545 5.45l9.436 5.09a.502.502 0 0 1 .002.885l-9.437 5.129a.512.512 0 0 1-.755-.443V14.575a.507.507 0 0 1 .754-.443zm.944 8.673l5.77-3.136-5.77-3.112v6.248zm11.323 11.634c0-.464.38-.84.85-.84.468 0 .848.376.848.84A2.563 2.563 0 0 1 39.887 37H17.566A2.563 2.563 0 0 1 15 34.44V12.082a2.563 2.563 0 0 1 2.566-2.56c.469 0 .849.376.849.84 0 .464-.38.84-.849.84a.874.874 0 0 0-.868.88v22.356c0 .488.39.88.868.88h22.321a.874.874 0 0 0 .868-.88z'
        fillRule='nonzero'
      />
      <text fontSize='14' fontWeight='bold'>
        <tspan x='13.088' y='51.923'>
          Video
        </tspan>
      </text>
    </g>
  </svg>
)

export default VideoWithTextIcon
